import { Injectable } from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';

@Injectable()
export class ProfileService extends BaseService {
  readonly prefixUrl =  UrlConstant.CURRENT_USER.PREFIX;
  getProfile() {
    return this.get(this.prefixUrl + UrlConstant.CURRENT_USER.PROFILE );
  }

  changeProfile(data: any) {
    return this.post(this.prefixUrl + UrlConstant.CURRENT_USER.CHANGE_PROFILE, data );
  }

  changePass(data: any) {
    return this.post(this.prefixUrl + UrlConstant.CURRENT_USER.CHANGE_PASS, data );
  }
}
